// extracted by mini-css-extract-plugin
export default {"container":"voucher-nav_container__4PG9M"};